/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Ikhemployee_Goethe17Inputs */

const en__field_enum_ikhemployee_goethe17 = /** @type {(inputs: _Field_Enum_Ikhemployee_Goethe17Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Techn.-Admin. Mitarb. der Goethe-Universität`)
};

const de__field_enum_ikhemployee_goethe17 = /** @type {(inputs: _Field_Enum_Ikhemployee_Goethe17Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Techn.-Admin. Mitarb. der Goethe-Universität`)
};

/**
* | output |
* | --- |
* | "Techn.-Admin. Mitarb. der Goethe-Universität" |
*
* @param {_Field_Enum_Ikhemployee_Goethe17Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_ikhemployee_goethe17 = /** @type {((inputs?: _Field_Enum_Ikhemployee_Goethe17Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Ikhemployee_Goethe17Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_ikhemployee_goethe17(inputs)
	return de__field_enum_ikhemployee_goethe17(inputs)
});
export { _field_enum_ikhemployee_goethe17 as "_field_enum_IKHEMPLOYEE_GOETHE" }